import React from 'react';
import { useAuth } from '../Auth/AuthContext';

const AdminViewToggle = ({ showAllView, onToggle }) => {
  const { hasPermission } = useAuth();
  const isAdmin = hasPermission('sourcing_lead', 'read_all');

  if (!isAdmin) return null;

  return (
    <div className="flex items-center gap-2">
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={showAllView}
          onChange={onToggle}
        />
        <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 
          peer-focus:ring-pink-300 rounded-full peer 
          peer-checked:after:translate-x-full peer-checked:after:border-white 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:border-gray-300 after:border after:rounded-full 
          after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500`}
        />
      </label>
      <span className="text-sm font-medium text-gray-700">
        {showAllView ? 'View All Leads' : 'View All Leads'}
      </span>
    </div>
  );
};

export default AdminViewToggle; 